import { render, staticRenderFns } from "./MainPanel.vue?vue&type=template&id=70205ea7&scoped=true"
import script from "./MainPanel.vue?vue&type=script&lang=ts"
export * from "./MainPanel.vue?vue&type=script&lang=ts"
import style0 from "./MainPanel.vue?vue&type=style&index=0&id=70205ea7&prod&lang=scss&scoped=true"
import style1 from "./MainPanel.vue?vue&type=style&index=1&id=70205ea7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70205ea7",
  null
  
)

export default component.exports